import {capitalizeFirstLetter} from '../../../helpers/common'


export const capitilize = value => value && capitalizeFirstLetter(value)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/normalize.js